import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { WindowUtil } from '../../utils/window-util';

export const QueryHandler = () => {
  const navigate = useNavigate();

  const callBack = (query: string, replace: boolean) => {
    void navigate(query, { replace });
  };

  useEffect(() => {
    WindowUtil.setNavigateCallback(callBack);
  }, []);

  return null;
};
